<template>
    <div class="bcw bcw__fert_ov">
        <header>
            <p class="title">
                {{ trans('dashboard.fert.title1') }}
                <span>{{ trans('dashboard.fert.title2') }}</span>
            </p>
            <tabs :tabs="myTabs" @switchTabControl="switchActiveFertilizer"></tabs>
        </header>
        <main v-if="activeNutrient">
            <ul class="scrollbar--vertical">
                <li
                    v-for="(low, i) in activeNutrient.parcels_low"
                    :key="i"
                    :class="'bglightfullx--' + low.crop.logo"
                >
                    <img :src="'/crop/pic/color/' + low.crop.logo" />
                    <div>
                        <p>{{ low.name }}</p>
                        <time
                            >{{ formatDate(low.date)
                            }}<span>{{ formatYear(low.date) }}</span></time
                        >
                    </div>
                    <p>{{ rankToString(low.rank.val) }}</p>
                </li>
                <li
                    v-if="activeNutrient.total_low > activeNutrient.parcels_low.length"
                    class="rest"
                >
                    <p
                        v-html="
                            $trans_choice(
                                'dashboard.fert.rest',
                                activeNutrient.total_low -
                                    activeNutrient.parcels_low.length
                            )
                        "
                    ></p>
                </li>
            </ul>
        </main>
        <main v-else class="zero__fert">
            <img src="/images/zero_dis.svg" />
            <p class="title">{{ trans('dashboard.fert.zero.title') }}</p>
            <p class="subtitle">{{ trans('dashboard.fert.zero.sub') }}</p>
        </main>
    </div>
</template>

<style lang="scss" scoped></style>

<script>
export default {
    props: ['widget'],

    data() {
        const filteredElements = this.widget.data().filter((element) => {
            return element.total_low > 0;
        });

        const myTabs = filteredElements.map((element, i) => {
            return {
                id: element.element,
                name: element.element,
                num: element.total_low,
                active: i === 0,
            };
        });

        return {
            myTabs,
            allNutrients: filteredElements,
            activeNutrient: filteredElements.length ? filteredElements[0] : null,
        };
    },

    methods: {
        switchActiveFertilizer(i) {
            this.myTabs.forEach((tab) => (tab.active = false));
            this.myTabs[i].active = true;
            this.activeTab = i;
            this.activeNutrient = this.allNutrients[i];
        },

        rankToString(lvl) {
            const lit = [
                trans('dashboard.insiders.lvls.vl'),
                trans('dashboard.insiders.lvls.l'),
                trans('dashboard.insiders.lvls.m'),
                trans('dashboard.insiders.lvls.h'),
                trans('dashboard.insiders.lvls.vh'),
            ];
            return lit[lvl - 1];
        },
        formatDate(mydate) {
            return moment(mydate).format('DDMMM').replace('.', '').toString();
        },
        formatYear(mydate) {
            return moment(mydate).format('YYYY').replace('.', '').toString();
        },
    },
};
</script>
